import React from 'react';
import { Alert, Container } from 'react-bootstrap';

const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <Container
      className="d-flex justify-content-center align-items-center vh-100"
    >
    <p style={{ color: 'red', fontSize: 'larger' }}>{message}</p>
    </Container>
  );
};

export default ErrorMessage;